import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { APP_ICONS } from './core/icons';
import { TenantProfileService } from './core/services/tenant-profile.service';
import { whatsappLink } from './core/utils/labels';
import { Footer } from './layout/footer/footer';
import { Header } from './layout/header/header';

@Component({
	selector: 'app-root',
	imports: [RouterOutlet, Header, Footer, FontAwesomeModule],
	templateUrl: './app.html',
})
export class App {
	private readonly brand = inject(TenantProfileService).brand();
	readonly waLink = whatsappLink(
		this.brand.whatsapp,
		`Halo ${this.brand.name}, saya ingin bertanya tentang paket perjalanan.`,
	);

	constructor() {
		// Registrasi seluruh ikon sekali untuk dipakai lintas komponen via <fa-icon>.
		inject(FaIconLibrary).addIcons(...APP_ICONS);
	}
}
